import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateUserComponent } from './create-user/create-user.component';
import { EmployeesGridComponent } from './employees-grid/employees-grid.component';

const routes: Routes = [
	{
		path: '',
		component: EmployeesGridComponent,
	},
	{
		path: 'create',
		component: CreateUserComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class UsersRoutingModule { }
